import * as api from "./apis/sendResetPasswordEmail";
import { emit, triggerError } from "../utils/eventManager";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
export { sendResetPasswordEmail };
async function sendResetPasswordEmail(clientId, email) {
  try {
    sendNewRelicEvent({
      EventName: 'send_reset_password_email_start'
    });
    var response = await api.sendResetPasswordEmail(clientId, email);
    emit('send_reset_password_email.success', response);
    sendNewRelicEvent({
      EventName: 'send_reset_password_email_success'
    });
    return response;
  } catch (e) {
    sendNewRelicEvent({
      EventName: 'send_reset_password_email_failed',
      error: e
    });
    triggerError('send reset password email', e);
    throw e;
  }
}